'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _kunaUtils = require('../../utils/kunaUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The component that shows recording thumbnails,
 * recording reasons, playback, ect
 */
var SightImagesDetail = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SightImagesDetail, _Component);

  function SightImagesDetail(props) {
    (0, _classCallCheck3.default)(this, SightImagesDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SightImagesDetail.__proto__ || (0, _getPrototypeOf2.default)(SightImagesDetail)).call(this, props));

    _this.state = { image: null };
    return _this;
  }

  (0, _createClass3.default)(SightImagesDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props$sightImage = this.props.sightImage,
          sn = _props$sightImage.camera_sn,
          label = _props$sightImage.label;


      var thumbUrl = (0, _kunaUtils.getSightImageThumbUrl)(sn, label);
      fetch(thumbUrl, {
        cache: 'force-cache'
      }).then(function (res) {
        if (res.status === 429 || res.status === 403) {
          return fetch(thumbUrl, { cache: 'reload' });
        }
        return res;
      }).then(function (res) {
        res.arrayBuffer().then(function (buffer) {
          var imageStr = (0, _kunaUtils.arrayBufferToBase64)(buffer);
          _this2.setState({ image: 'data:image/jpeg;base64,' + imageStr });
        });
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // if (this.props.onUpdate) {
      //   this.props.onUpdate();
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      var sightImage = this.props.sightImage;
      var image = this.state.image;


      var imageRatio = 16.0 / 9.0;

      var imageHeight = 200;
      var imageWidth = imageHeight * imageRatio;

      var sightImageSafe = sightImage || {};

      var reason = sightImageSafe.sight_data;


      var reasonSafe = reason || {};
      var sightImageB64 = reasonSafe.image_b64,
          objectReasons = reasonSafe.objects,
          reasonRest = (0, _objectWithoutProperties3.default)(reasonSafe, ['image_b64', 'objects']);


      var aiElement = function aiElement() {
        return _react2.default.createElement(
          'div',
          { style: { position: 'fixed' } },
          _react2.default.createElement('img', { height: imageHeight, alt: '', src: image }),
          objectReasons.map(function (obj, idx) {
            return _react2.default.createElement(_components.DetectionBox
            /* eslint-disable-next-line react/no-array-index-key */
            , { key: idx,
              detectionObj: obj,
              recordingReason: reasonRest,
              imageHeight: imageHeight,
              imageWidth: imageWidth
            });
          })
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            title: (0, _stringify2.default)(reasonRest, null, 2),
            style: { width: imageWidth }
          },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'b',
              null,
              sightImageSafe.label
            )
          )
        ),
        reason && aiElement()
      );
    }
  }]);
  return SightImagesDetail;
}(_react.Component), _class.propTypes = {
  sightImage: _react.PropTypes.object
}, _temp);
exports.default = SightImagesDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SightImagesDetail/SightImagesDetail.js
 ** module id = 1386
 ** module chunks = 0
 **/